import { Component, OnInit } from '@angular/core';
import { TablaComponent } from '../../shared/components/tabla/tabla.component';
import { GithubService } from '../services/github-service.service';
import { Ec2Repositories, IProjects } from '../../models';

@Component({
  selector: 'app-chennai',
  imports: [TablaComponent],
  templateUrl: './chennai.component.html',
  styleUrl: './chennai.component.scss',
})
export class ChennaiComponent implements OnInit {
  repositories: any = {};
  projects: IProjects = {};

  constructor(readonly _githubService: GithubService) {}

  ngOnInit(): void {
    this.getRepositories();
  }

  async getRepositories() {
    try {
      const response = await this._githubService.fetchRepositories();
      this.repositories = response.ec2Repositories;
    } catch (error) {
      console.error('Error fetching repositories:', error);
      throw error;
    } finally {
      await this.getContentRepositories();
    }
  }

  async getContentRepositories() {
    if (this.repositories && Array.isArray(this.repositories)) {
      try {
        const contentResponse =
          await this._githubService.fetchContentRepositories({
            ec2Repositories: this.repositories as any,
          });
        this.projects = contentResponse;
      } catch (error) {
        console.error('Error fetching content for repositories:', error);
      }
    }
  }
}
